import { TD } from '@/components/DesignLibrary/Table';

export type Props = {
  type: 'component';
  content: React.ReactNode;
};

const ComponentCell: React.FC<Props> = ({ content }) => (
  <TD>
    {content}
  </TD>
);

export default ComponentCell;
